'use client';

import { useMemo } from 'react';
import useTranslations from '@/hooks/useTranslations';

export default function YouTubeEmbed({ videoUrl }: { videoUrl: string }) {
  const videoId = useMemo(() => {
    // Extract video ID using URL pattern matching
    const urlObj = new URL(videoUrl);
    if (urlObj.hostname.includes('youtube.com')) {
      return new URLSearchParams(urlObj.search).get('v') || '';
    }
    // Handle youtu.be URLs
    if (urlObj.hostname === 'youtu.be') {
      return urlObj.pathname.substring(1);
    }
    return '';
  }, [videoUrl]);

  const { t } = useTranslations();

  return (
    <div
      style={{
        width: '100%',
        aspectRatio: '16/9',
      }}
    >
      <iframe
        src={`https://www.youtube.com/embed/${videoId}`}
        allowFullScreen
        allow={t('youtubeEmbed.allowedFeatures')}
        title={t('youtubeEmbed.player')}
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
        }}
      />
    </div>
  );
}
